module.exports = __webpack_public_path__ + "static/media/wma.593d486d.svg";